import { Controller } from "@hotwired/stimulus"

// A question block: which answer is the right one, and which fields the kind of
// question it is actually asks for. The right answer is kept in one hidden field
// per question, so two questions on a page never share a radio group.
export default class extends Controller {
  static targets = ["mark", "field", "kind", "answers", "explained", "exampled"]

  connect() {
    this.kinds()
    this.show()
  }

  choose(event) {
    event.preventDefault()
    this.chosen = event.currentTarget
    this.show()
  }

  markTargetConnected() {
    this.kinds()
    this.show()
  }

  markTargetDisconnected() {
    this.show()
  }

  // A poll has no right answer, and an open question has no answers at all.
  kinds() {
    const kind = this.hasKindTarget ? this.kindTarget.value : "quiz"

    this.markTargets.forEach((mark) => { mark.hidden = kind !== "quiz" })
    this.answersTargets.forEach((answers) => { answers.hidden = kind === "open" })
    this.explainedTargets.forEach((field) => { field.hidden = kind !== "quiz" })
    this.exampledTargets.forEach((field) => { field.hidden = kind !== "open" })
  }

  // The tick is held as the button it is on rather than as the number it had, so
  // taking an answer away above it moves it down instead of onto its neighbour.
  show() {
    if (!this.hasFieldTarget) return

    if (this.chosen) {
      const moved = this.markTargets.indexOf(this.chosen)
      this.fieldTarget.value = moved < 0 ? "" : moved
    }

    const at = this.fieldTarget.value === "" ? -1 : Number(this.fieldTarget.value)
    this.markTargets.forEach((mark, index) => {
      mark.toggleAttribute("data-right", index === at)
    })
    this.chosen = this.markTargets[at] || null
  }
}
